import { render, staticRenderFns } from "./AdmSlotPreload.vue?vue&type=template&id=51bc51df&scoped=true"
import script from "./AdmSlotPreload.vue?vue&type=script&lang=js"
export * from "./AdmSlotPreload.vue?vue&type=script&lang=js"
import style0 from "./AdmSlotPreload.vue?vue&type=style&index=0&id=51bc51df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51bc51df",
  null
  
)

export default component.exports